import * as React from 'react'
import { useRef, useState } from 'react'
import { POPUP_OPTION } from 'src/constant/popup'

import _Button from '@/component/atoms/Button/_Button/_Button'
import Checkbox from '@/component/atoms/Checkbox/_Checkbox/_Checkbox'
import { Icon } from '@/component/atoms/Icon'
import modalService from '@/service/modal.service'

import ConfirmModalStyled from './ConfirmModal.style'

export type ConfirmModalProps = {
  hasIcon?: boolean
  title?: string
  content?: React.ReactNode
  onClick: React.MouseEventHandler<HTMLButtonElement>
  onCancel?: React.MouseEventHandler<HTMLButtonElement>
  actionButtonText?: string
  actionButtonDisabled?: boolean
  cancelButtonText?: string
  hasCancelButton?: boolean
  doNotShowAgainOption?: boolean
  showRightBottomCloseTextButton?: boolean
  handleDoNotShowAgainOption?: (option: boolean) => void
}
const ConfirmModal = ({
  hasIcon = false,
  title,
  content,
  onClick,
  onCancel = () => {
    modalService.closeModal()
  },
  actionButtonText = '확인',
  cancelButtonText = '취소',
  hasCancelButton = true,
  doNotShowAgainOption = false,
  showRightBottomCloseTextButton = false,
  actionButtonDisabled = false,
  handleDoNotShowAgainOption,
}: ConfirmModalProps) => {
  const [loading, setLoading] = useState(false)
  const checkboxRef = useRef<HTMLInputElement>(null)

  // 다시 보지 않기 옵션일 경우에만 동작
  React.useEffect(() => {
    const checkbox = checkboxRef.current
    return () => {
      if (checkbox && checkbox.checked && handleDoNotShowAgainOption) {
        handleDoNotShowAgainOption(checkbox.checked)
      }
    }
  }, [checkboxRef.current])

  return (
    <ConfirmModalStyled>
      <div className="confirm-modal-container">
        {(title || hasIcon) && (
          <div className="confirm-modal-header">
            {hasIcon && <Icon name="check_circle" />}
            {title && <h2>{title}</h2>}
          </div>
        )}
        {content && <div className="confirm-modal-body">{content}</div>}
        <div className="confirm-modal-footer">
          {hasCancelButton && (
            <_Button theme="light-solid" onClick={onCancel} size="m" minWidth={120}>
              {cancelButtonText}
            </_Button>
          )}
          <_Button
            minWidth={120}
            size="m"
            theme="primary"
            loading={loading}
            disabled={actionButtonDisabled}
            onClick={async (e) => {
              setLoading(true)
              await onClick(e)
              setLoading(false)
            }}
          >
            {actionButtonText}
          </_Button>
        </div>
      </div>
      <div className="confirm-modal-option">
        {doNotShowAgainOption && (
          <Checkbox
            ref={checkboxRef}
            className="option"
            text={POPUP_OPTION['DO_NOT_SHOW_AGAIN']}
            onChange={handleDoNotShowAgainOption}
          />
        )}
        {showRightBottomCloseTextButton && (
          <button className="right-bottom-close-text-button" onClick={onCancel}>
            닫기
          </button>
        )}
      </div>
    </ConfirmModalStyled>
  )
}

export default ConfirmModal
